export const categories = [
  {
    slug: "rpg",
    name: "角色扮演 (RPG)",
    description: "以沉浸式剧情与角色成长为核心的工口RPG游戏，玩家可体验丰富的主线故事与支线任务",
    icon: "ri-gamepad-line",
    count: 28,
  },
  {
    slug: "avg",
    name: "文字冒险 (AVG)",
    description: "以文字叙述与选择分支驱动的视觉小说类工口游戏，多重结局带来高重玩价值",
    icon: "ri-book-open-line",
    count: 35,
  },
  {
    slug: "slg",
    name: "策略模拟 (SLG)",
    description: "结合经营养成与策略玩法的工口游戏，玩家需管理资源与角色关系",
    icon: "ri-bar-chart-box-line",
    count: 22,
  },
  {
    slug: "act",
    name: "动作战斗 (ACT)",
    description: "强调操作手感与实时战斗的工口动作游戏，兼具挑战性与视觉表现力",
    icon: "ri-sword-line",
    count: 15,
  },
  {
    slug: "puzzle",
    name: "益智解谜 (Puzzle)",
    description: "通过解谜推进剧情发展的工口游戏，考验逻辑思维与观察力",
    icon: "ri-lightbulb-line",
    count: 12,
  },
  {
    slug: "sandbox",
    name: "沙盒自由 (Sandbox)",
    description: "高自由度开放世界工口游戏，玩家可自由探索与触发多样事件",
    icon: "ri-global-line",
    count: 18,
  },
  {
    slug: "simulation",
    name: "生活模拟 (Simulation)",
    description: "模拟真实生活场景的工口游戏，包含养成、社交与日常互动要素",
    icon: "ri-home-heart-line",
    count: 20,
  },
  {
    slug: "doujin",
    name: "同人佳作 (Doujin)",
    description: "由同人社团制作的精品工口游戏，风格多样创意十足",
    icon: "ri-brush-line",
    count: 40,
  },
];

export const articles = [
  {
    slug: "top-10-rpg-2025",
    title: "2025年必玩十大工口RPG推荐排行",
    excerpt: "为你精选本年度最值得体验的十款工口RPG作品，从经典续作到全新IP，覆盖不同题材与玩法风格，助你快速找到下一款心头好。",
    category: "rpg",
    image: "https://readdy.ai/api/search-image?query=Dark%20fantasy%20RPG%20game%20art%20style%20scene%20with%20medieval%20castle%20silhouette%20and%20mysterious%20purple%20atmosphere%2C%20dramatic%20lighting%20with%20crimson%20accents%2C%20game%20illustration%20aesthetic%2C%20cinematic%20composition%2C%20warm%20and%20dark%20contrast&width=800&height=500&seq=rpg-top-10-2025&orientation=landscape",
    date: "2025-12-15",
    rating: 4.8,
    author: "攻略组-星野",
    readTime: "12分钟",
    content: `
      <h2>前言</h2>
      <p>工口RPG作为工口游戏中最具深度的品类之一，凭借丰富的剧情线与角色成长系统，持续吸引着大批玩家。2025年涌现了多款优秀作品，本篇将为你盘点十款不容错过的工口RPG佳作。</p>
      
      <h2>第一名：暗影编年史 Shadow Chronicle</h2>
      <p>融合了克苏鲁神话元素的暗黑奇幻RPG，玩家扮演一名在诅咒之地求生的冒险者。游戏拥有超过40小时的主线剧情，战斗系统采用半即时制，策略深度令人惊喜。角色设计精美，CG质量极高。</p>
      <p><strong>推荐理由：</strong>剧情深度与角色塑造达到业界顶尖水准，战斗系统兼具挑战与乐趣。</p>
      
      <h2>第二名：星之轨迹 Stellar Path</h2>
      <p>以太空歌剧为背景的科幻RPG，讲述了人类在银河系边缘殖民地求生的故事。游戏融合了探索、战斗与角色养成三大系统，自由度高，多结局设计让重玩价值倍增。</p>
      <p><strong>推荐理由：</strong>世界观设定宏大多元，自由探索系统让每个玩家的体验都独一无二。</p>
      
      <h2>第三名：绯红之心 Crimson Heart</h2>
      <p>经典日式RPG风格的工口作品，以中世纪魔法学院为舞台。精美的立绘与华丽的魔法特效是最大亮点，角色间的羁绊系统设计细腻动人。</p>
      <p><strong>推荐理由：</strong>学院日常与主线战斗的节奏把控出色，角色魅力十足。</p>
      
      <h2>总结</h2>
      <p>以上三款作品各具特色，无论你是剧情党、探索控还是养成爱好者，都能找到适合自己的那一款。后续排名作品同样值得期待，欢迎持续关注我们的更新。</p>
    `,
  },
  {
    slug: "avg-masterpiece-ranking",
    title: "工口AVG神作排行榜：剧情与画风的双重盛宴",
    excerpt: "盘点工口AVG领域的里程碑级作品，从催泪神作到悬疑名篇，每一部都是不可错过的视觉小说佳作。",
    category: "avg",
    image: "https://readdy.ai/api/search-image?query=Visual%20novel%20game%20art%20style%20illustration%20with%20anime%20characters%20in%20dramatic%20scene%2C%20cherry%20blossom%20petals%20falling%2C%20warm%20sunset%20lighting%2C%20emotional%20atmosphere%2C%20game%20CG%20quality%2C%20soft%20cinematic%20composition&width=800&height=500&seq=avg-ranking-main&orientation=landscape",
    date: "2025-11-28",
    rating: 4.9,
    author: "编辑-雪月",
    readTime: "15分钟",
    content: `
      <h2>序言</h2>
      <p>文字冒险游戏（AVG）是工口游戏中最具文学性的品类。优秀的工口AVG往往拥有不输于传统文学作品的叙事深度，搭配精美的CG美术，带来独特的沉浸式体验。</p>
      
      <h2>神作级：白诘草之诗</h2>
      <p>被誉为工口AVG界的"文学级作品"，以明治时代为背景，讲述了一段跨越阶级的悲恋故事。剧本长达百万字，人物心理描写细腻入微。音乐由著名作曲家操刀，每一首BGM都与场景完美融合。</p>
      <p><strong>核心魅力：</strong>文学性与情感张力达到极致，被誉为"让人哭到停不下来"的神作。</p>
      
      <h2>准神作：夜明前的琉璃色</h2>
      <p>以月面都市为舞台的科幻AVG，融合了政治、科技与爱情三大主题。多视角叙事手法让故事层次丰富，每位女主角的线路都有独立的主题与风格。</p>
      <p><strong>核心魅力：</strong>宏大的科幻世界观与细腻的情感描写完美结合。</p>
      
      <h2>名作：七色星露</h2>
      <p>以魔法校园为舞台的奇幻AVG，画风华丽，CG数量超过200枚。恋爱线与主线剧情交织推进，节奏把控极为到位。</p>
      <p><strong>核心魅力：</strong>顶级的视觉表现与甜度爆表的恋爱体验。</p>
    `,
  },
  {
    slug: "slg-new-release-guide",
    title: "工口SLG新作入坑指南：从零开始的策略养成之旅",
    excerpt: "全面解析当前热门工口SLG新作，涵盖系统机制、养成路线与高效攻略，帮助新手玩家快速上手。",
    category: "slg",
    image: "https://readdy.ai/api/search-image?query=Strategy%20game%20interface%20with%2C%20medieval%20kingdom%20management%20theme%2C%20warm%20golden%20lighting%2C%20game%20UI%20elements%2C%20map%20and%20resource%20icons%2C%20rich%20detailed%20illustration%20style%2C%20dark%20wood%20texture%20background&width=800&height=500&seq=slg-guide-main&orientation=landscape",
    date: "2025-12-08",
    rating: 4.6,
    author: "攻略组-铁拳",
    readTime: "10分钟",
    content: `
      <h2>入门指南</h2>
      <p>工口SLG游戏融合了策略管理与角色养成两大核心玩法，对于新玩家来说，面对复杂的系统可能会感到不知所措。本指南将帮你快速建立游戏认知。</p>
      
      <h2>系统解析</h2>
      <p>SLG工口游戏的核心系统通常包含：资源管理（金币、素材、体力等）、角色养成（等级、技能、好感度）、事件触发（主线剧情、角色事件、随机事件）。理解这三者之间的关系是高效游玩的基础。</p>
      
      <h2>推荐新作</h2>
      <p><strong>王国复兴录：</strong>以中世纪王国经营为主题，玩家需管理领地、发展经济并与邻国交涉。角色事件丰富，养成路线多样。</p>
      <p><strong>学园经营部：</strong>以校园为舞台的轻量SLG，系统简洁友好，适合SLG新手入门。角色设计清新可爱，日常事件丰富。</p>
      
      <h2>高效攻略技巧</h2>
      <p>1. 优先提升资源产出建筑等级</p>
      <p>2. 每日登录奖励不可错过</p>
      <p>3. 好感度事件触发有特定时间段要求</p>
      <p>4. 多存档备份，方便尝试不同路线</p>
    `,
  },
  {
    slug: "act-must-play-list",
    title: "工口ACT必玩清单：手感与视觉的双重冲击",
    excerpt: "精选多款操作手感一流的工口动作游戏，从横版闯关到3D动作冒险，满足不同ACT爱好者的需求。",
    category: "act",
    image: "https://readdy.ai/api/search-image?query=Action%20game%20combat%20scene%20with%20dynamic%20sword%20effects%2C%20dark%20gothic%20castle%20background%2C%20dramatic%20red%20and%20gold%20particle%20effects%2C%20anime%20game%20art%20style%2C%20intense%20battle%20atmosphere%2C%20cinematic%20action%20shot&width=800&height=500&seq=act-list-main&orientation=landscape",
    date: "2025-12-01",
    rating: 4.5,
    author: "编辑-闪刃",
    readTime: "8分钟",
    content: `
      <h2>ACT工口游戏概述</h2>
      <p>动作类工口游戏对操作手感要求极高，优秀的工口ACT不仅能带来视觉享受，更能让玩家体验到酣畅淋漓的战斗快感。</p>
      
      <h2>横版卷轴经典</h2>
      <p><strong>恶魔城夜曲：</strong>致敬经典《恶魔城》系列的探索型ACT，地图设计精巧，敌人种类丰富。流畅的连击系统与丰富的技能树让战斗充满变化。</p>
      
      <h2>3D动作新秀</h2>
      <p><strong>深渊行者：</strong>采用第三人称视角的3D工口ACT，以黑暗奇幻世界为舞台。战斗系统借鉴了类魂系列的精华，打击感扎实，BOSS战设计令人印象深刻。</p>
      
      <h2>Roguelike ACT</h2>
      <p><strong>无限迷宫：</strong>随机生成地图的Roguelike工口ACT，每次冒险都是全新体验。道具组合多变，Build流派丰富。</p>
    `,
  },
  {
    slug: "downloading-platform-guide",
    title: "工口游戏下载平台全攻略：安全获取与安装指南",
    excerpt: "详细介绍各大工口游戏下载平台的优缺点，包含支付方式、下载速度与安全性的全面对比。",
    category: "doujin",
    image: "https://readdy.ai/api/search-image?query=Digital%20game%20store%20interface%20with%20colorful%20game%20covers%20displayed%2C%20warm%20dark%20theme%2C%20modern%20UI%20design%2C%20gaming%20platform%20aesthetic%2C%20soft%20neon%20accents%2C%20digital%20distribution%20concept&width=800&height=500&seq=download-guide&orientation=landscape",
    date: "2025-11-20",
    rating: 4.7,
    author: "攻略组-导航员",
    readTime: "14分钟",
    content: `
      <h2>平台选择指南</h2>
      <p>选择一个可靠的下载平台是获取工口游戏的第一步。不同平台在游戏数量、价格策略、下载体验方面各有差异。本指南将帮助你做出最佳选择。</p>
      
      <h2>DLsite</h2>
      <p>日本最大的同人与工口游戏数字销售平台，游戏数量超过10万款。支持中文界面，部分作品有官方中文版。支付方式支持信用卡与点数卡。</p>
      <p><strong>优点：</strong>游戏数量最多，同人作品丰富，定期有折扣活动</p>
      <p><strong>缺点：</strong>部分老作品无中文支持</p>
      
      <h2>Steam</h2>
      <p>全球最大的数字游戏平台，近年来工口游戏数量显著增长。需注意Steam版的工口游戏可能存在内容删减，建议配合补丁使用。</p>
      <p><strong>优点：</strong>支付便捷，下载速度快，退款政策友好</p>
      <p><strong>缺点：</strong>部分作品有内容审查</p>
      
      <h2>FANZA GAMES</h2>
      <p>日本最大的工口游戏专营平台，涵盖商业大作与同人作品。需要日本IP访问，对海外玩家有一定门槛。</p>
    `,
  },
  {
    slug: "puzzle-recommend-2025",
    title: "烧脑与浪漫并存：2025年工口解谜游戏精选",
    excerpt: "为你推荐五款将解谜与浪漫巧妙结合的工口游戏，逻辑挑战与剧情推进完美交融。",
    category: "puzzle",
    image: "https://readdy.ai/api/search-image?query=Mysterious%20puzzle%20game%20scene%20with%20ancient%20runes%20and%20magical%20symbols%2C%20warm%20candlelight%20illumination%2C%20dark%20wooden%20table%20surface%2C%20mystical%20atmosphere%2C%20game%20art%20style%2C%20rich%20amber%20and%20crimson%20tones&width=800&height=500&seq=puzzle-2025&orientation=landscape",
    date: "2025-10-15",
    rating: 4.4,
    author: "编辑-智者",
    readTime: "9分钟",
    content: `
      <h2>解谜与浪漫的融合</h2>
      <p>益智解谜类工口游戏在考验玩家智力的同时，也将浪漫元素巧妙地编织在谜题之中。成功解开谜题的成就感与剧情推进的满足感相互叠加，形成了独特的吸引力。</p>
      
      <h2>推荐作品</h2>
      <p><strong>谜之馆：</strong>以神秘古宅为舞台的逃脱解谜游戏，每个房间都隐藏着秘密与故事。谜题设计精巧且逻辑自洽。</p>
      <p><strong>星图之谜：</strong>融合了占星元素的解谜AVG，通过解读星图推进剧情，画面唯美，音乐悠扬。</p>
    `,
  },
  {
    slug: "sandbox-open-world",
    title: "工口沙盒游戏：自由探索的无限可能",
    excerpt: "高自由度沙盒工口游戏大盘点，从奇幻大陆到现代都市，随心所欲地探索与冒险。",
    category: "sandbox",
    image: "https://readdy.ai/api/search-image?query=Open%20world%20fantasy%20landscape%20with%20rolling%20hills%20and%20ancient%20ruins%2C%20warm%20golden%20sunset%20lighting%2C%20adventure%20game%20atmosphere%2C%20vast%20explorable%20environment%2C%20game%20illustration%20style%2C%20rich%20colors&width=800&height=500&seq=sandbox-world&orientation=landscape",
    date: "2025-10-05",
    rating: 4.3,
    author: "攻略组-流浪者",
    readTime: "11分钟",
    content: `
      <h2>沙盒游戏的魅力</h2>
      <p>沙盒类工口游戏以其高自由度和开放世界著称。玩家可以按照自己的节奏探索世界，触发事件，与角色互动。没有固定的线性流程，每个玩家的旅程都是独一无二的。</p>
      
      <h2>推荐作品</h2>
      <p><strong>自由之翼：</strong>以浮空岛屿为舞台的奇幻沙盒，玩家可自由飞行探索不同岛屿，每个岛屿都有独特的生态与事件。</p>
      <p><strong>都市夜想：</strong>现代都市背景沙盒，模拟真实城市生活，自由度极高，NPC AI设计生动自然。</p>
    `,
  },
  {
    slug: "simulation-life-guide",
    title: "工口生活模拟游戏入门：从日常中发现浪漫",
    excerpt: "生活模拟类工口游戏攻略合集，涵盖角色养成、社交系统与隐藏事件触发条件详解。",
    category: "simulation",
    image: "https://readdy.ai/api/search-image?query=Cozy%20anime%20style%20room%20interior%20with%20warm%20sunlight%20through%20window%2C%20daily%20life%20scene%2C%20soft%20pastel%20colors%2C%20comfortable%20atmosphere%2C%20game%20background%20art%2C%20peaceful%20composition&width=800&height=500&seq=sim-life&orientation=landscape",
    date: "2025-09-22",
    rating: 4.5,
    author: "编辑-日常君",
    readTime: "10分钟",
    content: `
      <h2>生活模拟的魅力</h2>
      <p>生活模拟类工口游戏将浪漫融入日常，通过与角色建立关系、参与各种活动，逐渐发展出独特的故事。这类游戏节奏平和，适合喜欢慢慢品味剧情的玩家。</p>
      
      <h2>推荐作品</h2>
      <p><strong>向日葵之家：</strong>以合租公寓为舞台，与室友们共度温馨日常。角色AI设计出色，对话自然生动。</p>
      <p><strong>海风小镇：</strong>以海边小镇为舞台，融合了经营与社交玩法。钓鱼、烹饪、园艺等日常活动丰富多彩。</p>
    `,
  },
];

export const featuredGames = [
  {
    slug: "shadow-chronicle",
    title: "暗影编年史",
    category: "rpg",
    rating: 4.8,
    image: "https://readdy.ai/api/search-image?query=Dark%20fantasy%20game%20cover%20art%20with%20mysterious%20hooded%20character%20holding%20ancient%20sword%2C%20gothic%20castle%20in%20background%2C%20dramatic%20crimson%20and%20black%20color%20scheme%2C%20game%20box%20art%20style%2C%20epic%20atmosphere&width=600&height=400&seq=featured-shadow&orientation=landscape",
  },
  {
    slug: "stellar-path",
    title: "星之轨迹",
    category: "rpg",
    rating: 4.7,
    image: "https://readdy.ai/api/search-image?query=Space%20opera%20game%20art%20with%20starship%20and%20distant%20galaxy%2C%20beautiful%20nebula%20colors%2C%20sci-fi%20illustration%2C%20dramatic%20cosmic%20lighting%2C%20game%20cover%20design%2C%20deep%20space%20background&width=600&height=400&seq=featured-stellar&orientation=landscape",
  },
  {
    slug: "crimson-heart",
    title: "绯红之心",
    category: "rpg",
    rating: 4.6,
    image: "https://readdy.ai/api/search-image?query=Magic%20academy%20game%20art%20with%20elegant%20characters%20in%20school%20uniforms%2C%20floating%20magical%20sparks%2C%20warm%20golden%20and%20crimson%20color%20palette%2C%20anime%20game%20illustration%20style%2C%20enchanting%20atmosphere&width=600&height=400&seq=featured-crimson&orientation=landscape",
  },
  {
    slug: "white-clover-poem",
    title: "白诘草之诗",
    category: "avg",
    rating: 4.9,
    image: "https://readdy.ai/api/search-image?query=Meiji%20era%20romance%20visual%20novel%20art%20with%20kimono%20characters%20under%20cherry%20blossoms%2C%20nostalgic%20warm%20lighting%2C%20traditional%20Japanese%20aesthetic%2C%20soft%20watercolor%20style%2C%20emotional%20atmosphere&width=600&height=400&seq=featured-white&orientation=landscape",
  },
  {
    slug: "kingdom-revival",
    title: "王国复兴录",
    category: "slg",
    rating: 4.5,
    image: "https://readdy.ai/api/search-image?query=Medieval%20kingdom%20strategy%20game%20art%20with%20castle%20and%20map%2C%20golden%20banners%20and%20royal%20crown%2C%20warm%20rich%20colors%2C%20game%20illustration%2C%20epic%20fantasy%20style&width=600&height=400&seq=featured-kingdom&orientation=landscape",
  },
  {
    slug: "abyss-walker",
    title: "深渊行者",
    category: "act",
    rating: 4.4,
    image: "https://readdy.ai/api/search-image?query=Dark%20fantasy%20action%20game%20art%20with%20armored%20warrior%20facing%20giant%20monster%2C%20dramatic%20battle%20scene%2C%20gothic%20atmosphere%2C%20dynamic%20pose%2C%20game%20cover%20style&width=600&height=400&seq=featured-abyss&orientation=landscape",
  },
];

export const hotRankings = [
  { rank: 1, title: "暗影编年史", category: "RPG", rating: 4.8, trend: "up" },
  { rank: 2, title: "白诘草之诗", category: "AVG", rating: 4.9, trend: "stable" },
  { rank: 3, title: "星之轨迹", category: "RPG", rating: 4.7, trend: "up" },
  { rank: 4, title: "夜明前的琉璃色", category: "AVG", rating: 4.8, trend: "stable" },
  { rank: 5, title: "王国复兴录", category: "SLG", rating: 4.5, trend: "up" },
  { rank: 6, title: "绯红之心", category: "RPG", rating: 4.6, trend: "down" },
  { rank: 7, title: "恶魔城夜曲", category: "ACT", rating: 4.4, trend: "up" },
  { rank: 8, title: "七色星露", category: "AVG", rating: 4.5, trend: "stable" },
  { rank: 9, title: "深渊行者", category: "ACT", rating: 4.4, trend: "up" },
  { rank: 10, title: "自由之翼", category: "Sandbox", rating: 4.3, trend: "up" },
];

export const latestNews = [
  {
    slug: "winter-sale-2025",
    title: "年末冬促开启：各大平台工口游戏折扣汇总",
    excerpt: "DLsite、Steam、FANZA三大平台年末促销已全面开启，多款人气工口游戏迎来历史最低价。",
    image: "https://readdy.ai/api/search-image?query=Winter%20sale%20banner%20with%20snowflakes%20and%20gift%20boxes%2C%20warm%20festive%20atmosphere%2C%20golden%20and%20white%20color%20scheme%2C%20promotional%20design%20style%2C%20cozy%20vibe&width=800&height=500&seq=winter-sale&orientation=landscape",
    date: "2025-12-20",
    category: "news",
  },
  {
    slug: "steam-policy-update",
    title: "Steam内容政策更新：对工口游戏的影响分析",
    excerpt: "Valve近日更新了Steam内容审查政策，多款等待上架的工口游戏可能受到影响。",
    image: "https://readdy.ai/api/search-image?query=Digital%20storefront%20interface%20with%20policy%20document%20concept%2C%20warm%20modern%20design%2C%20gaming%20platform%20theme%2C%20soft%20lighting%2C%20clean%20professional%20style&width=800&height=500&seq=steam-policy&orientation=landscape",
    date: "2025-12-18",
    category: "news",
  },
  {
    slug: "new-release-january",
    title: "2026年1月工口游戏新作发售日历",
    excerpt: "整理2026年1月即将发售的工口游戏新作，包含RPG、AVG、SLG等多个品类，提前规划你的游戏清单。",
    image: "https://readdy.ai/api/search-image?query=Calendar%20with%20game%20cover%20art%20thumbnails%2C%20new%20year%202026%20theme%2C%20warm%20festive%20design%2C%20celebration%20atmosphere%2C%20colorful%20game%20box%20art%20collection&width=800&height=500&seq=new-release-jan&orientation=landscape",
    date: "2025-12-16",
    category: "news",
  },
];